import { defineStore } from "pinia";
import { ref } from "vue";
import { useAxios } from "@/composables/api.js";
import { catchError } from "@/composables/error.js";

export const useAssessmentStore = defineStore("assessment", () => {
  const assessments = ref([]);

  const results = ref(null);

  async function getCandidateAssessments() {
    try {
      const { data } = await useAxios.get("/candidates/me/assessments");

      assessments.value = data.assessments;
      results.value = data.results;

      return data;
    } catch (error) {
      return catchError(error);
    }
  }

  function clear() {
    assessments.value = [];
    results.value = [];
  }

  return {
    assessments,
    results,
    clear,
    getCandidateAssessments,
  };
});
